import React from 'react';
import s from './ExitpollTableView.scss';

const ExitpollTableView = ({ data, partiesToShow = null }) => {
  if (!data) return null;

  const sources = Object.keys(data);
  if (sources.length === 0) return null;

  const partiesToShowArray = partiesToShow.split(',');

  return (
    <div className={s.tableWrap}>
      <table className={s.customTable}>
        <thead>
          <tr>
            <th>Source</th>
            {partiesToShowArray &&
              Array.isArray(partiesToShowArray) &&
              partiesToShowArray.length > 0 &&
              partiesToShowArray.map(party => (
                <th
                  key={party}
                  style={{
                    backgroundColor: data[sources[0]][party]?.color,
                  }}
                >
                  {party}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {sources &&
            Array.isArray(sources) &&
            sources.length > 0 &&
            sources.map(source => (
              <tr key={source}>
                <td>{source}</td>
                {partiesToShowArray &&
                  Array.isArray(partiesToShowArray) &&
                  partiesToShowArray.length > 0 &&
                  partiesToShowArray.map(party =>
                    (() => {
                      if (
                        data?.[source]?.[party]?.wsc != null &&
                        data?.[source]?.[party]?.wsc === '-'
                      ) {
                        return (
                          <td
                            style={{
                              color: data?.[source]?.[party]?.color,
                            }}
                          >
                            {data?.[source]?.[party]?.wsc}
                          </td>
                        );
                      } else if (
                        data?.[source]?.[party]?.wsc != null &&
                        data?.[source]?.[party]?.wsc !== '-' &&
                        data?.[source]?.[party]?.ls ===
                          data?.[source]?.[party]?.wsc
                      ) {
                        return (
                          <td
                            style={{
                              color: data?.[source]?.[party]?.color,
                            }}
                          >{`${
                            isNaN(data?.[source]?.[party]?.ls)
                              ? 0
                              : data?.[source]?.[party]?.ls
                          }`}</td>
                        );
                      }
                      return (
                        <td
                          style={{
                            color: data?.[source]?.[party]?.color,
                          }}
                        >
                          {`${
                            isNaN(data?.[source]?.[party]?.ls)
                              ? 0
                              : data?.[source]?.[party]?.ls
                          } - ${
                            isNaN(data?.[source]?.[party]?.wsc)
                              ? 0
                              : data?.[source]?.[party]?.wsc
                          }`}
                        </td>
                      );
                    })(),
                  )}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ExitpollTableView;
